import e from "./index.ce.vue.js";
import { defineAndRegisterElement as r } from "../../utils/register-element.js";
const n = r(e);
export {
  n as initBrandCategorySelector
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/brand-category-selector/index.js
// module id = 1183
// module chunks = 41